import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { Constants } from 'src/shared/utilities/constants.util';
import { EntityAdminConfig } from 'src/shared/Baseclasses/entity-admin.component';
import { UnitsOfService } from 'src/shared/models/units-of-service.model';
import { UnitsOfServiceService } from 'src/shared/services/units-of-service.service';
import { PageLayoutService } from 'src/shared/services/page-layout.service';

@Component({
    selector: 'smt-Units-Of-Service',
    templateUrl: './units-of-service.component.html',
    styleUrls: ['./units-of-service.component.scss']
})
export class UnitsOfServiceComponent extends EntityAdminConfig implements OnDestroy, OnInit {
    @ViewChild('UnitsOfServiceEditForm') public UnitsOfServiceEditForm: NgForm;

    enablecategory: boolean;
    UnitsOfServices: UnitsOfService[];
    mostRecent: boolean;
    selectedCategory: string;


    constructor(private _UnitsOfServiceService: UnitsOfServiceService, private _pageLayout: PageLayoutService) {
        super(_pageLayout);
    }

    ngOnDestroy() {
        super.cleanUp();
    }

    ngOnInit() {
        super.initialize(
            Constants.UnitsOfService,
            ["Category", "Last Modified"],
            async () => this.setSelectedUnitsofserviceValues(),
            async (mostRecent: boolean) => this.refreshUnitsOfServiceList(mostRecent),
            async () => this.appendUnitsofserviceList(),
            async () => this.saveUnitsOfService(),
            () => this.setCurrentSelectionLabel(),
            () => { return "Remove"; });
    }
    async appendUnitsofserviceList(): Promise<void> {
        let result = await this._UnitsOfServiceService.GetUnitsOfServices(
            false,
            this.offset,
            this.itemsPerPage,
            this.searchText,
            this.selectedFilter,
            this.getSortOrderString());

        this.UnitsOfServices = this.UnitsOfServices.concat(result);
    }

    onAddUnitsOfserviceClick() {
        this.selection = {
            id: 0,
            Category: '',
            modifiedByUserName: '',
            modifiedDate: null
        };

        this.showAdminActionWindow = true;
        super.limitAdminActionLabel();
        this.setSelectedUnitsofserviceValues();
    }

    onCancel() {
        super.onCancel();
        this.setSelectedUnitsofserviceValues();
        this.resetForm();
    }

    onSelection(unit: UnitsOfService) {
        this.resetForm();
        super.onSelection(unit);
    }

    async onRemoveUnitsOfServiceClick() {
        if (!this.selection) {
            return;
        }
        let categoryInUse = await this._UnitsOfServiceService.UnitsOfServiceCategoryInUse(this.selection.id);
        if (!categoryInUse) {
            let result = await this._UnitsOfServiceService.RemoveUnitsOfService(this.selection.id);
            this.confirmModalActive = false;
            if (result) {
                super.refreshAdminList(false, false);
            }
            else {
                super.setErrorMessage("Units Of Service delete failed.");
            }
        }
        else {
            this.confirmModalActive = false;
            super.setErrorMessage("Units Of Service Catagory is being used. Unable to perfrom delete.");
        }
    }

    async refreshUnitsOfServiceList(mostRecent: boolean): Promise<UnitsOfService[]> {
        let result = await this._UnitsOfServiceService.GetUnitsOfServices(
            mostRecent,
            this.offset,
            this.itemsPerPage,
            this.searchText,
            this.selectedFilter,
            this.getSortOrderString());

        this.UnitsOfServices = result;

        this.setSelectedUnitsofserviceValues();
        this.resetForm();

        return result;
    }

    resetForm() {
        if (!this.UnitsOfServiceEditForm) {
            return;
        }

        Object.keys(this.UnitsOfServiceEditForm.controls).forEach(control => {
            this.UnitsOfServiceEditForm.controls[control].markAsPristine();
        });
    }

    async saveUnitsOfService() {
        if (!this.selection) {
            return;
        }

        let mostRecent = this.selection.id == 0;

        let selectedUnitsOfService = new UnitsOfService;

        selectedUnitsOfService.id = this.selection.id;
        selectedUnitsOfService.category = this.selectedCategory;

        //When creating a new item check if there is a duplicate
        let existingUnitsOfService = await this._UnitsOfServiceService.GetUnitsOfServiceByCategory(this.selectedCategory);

        if (existingUnitsOfService && existingUnitsOfService.id != selectedUnitsOfService.id) {
            super.setErrorMessage("Save failed.  The entered category is a duplicate.");
            return;
        }
        let result = await this._UnitsOfServiceService.setUnitsOfService(selectedUnitsOfService);

        this.selection.id = result;
        this.selection.category = selectedUnitsOfService.category;


        await super.refreshAdminList(mostRecent, true);

        if (result > 0) {
            this.resetForm();
        }
        else {
            super.setErrorMessage("Units of service failed to save.");
        }
    }

    setCurrentSelectionLabel(): string {
        if (!this.selection) {
            return "";
        }

        if (this.selection.id == 0) {
            return "New Category";
        }

        return this.selection.category;
    }

    setSelectedUnitsofserviceValues() {
        super.setErrorMessage("");

        if (this.selection) {
            this.selectedCategory = this.selection.category;
            this.enablecategory = this.selection.id == 0;
        }
        else {
            this.selectedCategory = "";
            this.enablecategory = true;
        }
    }
}
